/* Olilu product page.
   [data-pdp]          gallery (thumbnail column, hover photo, zoom), colour swap via the Section Rendering API, sizes,
                       "How many pairs?", add to basket, the phone bar, tabs, newest review line, "Wear it with", ad reviews
   [data-pdp-reviews]  "Etsy reviews of this design": summary, histogram filter, sort, photos, design/all toggle, show more
   [data-pdp-recs]     "You may also like": recommendations from other categories
   Loaded by several sections, so it guards against running twice. Needs assets/olilu.js. */
(function () {
  'use strict';
  if (window.__oliluPdp) return;
  window.__oliluPdp = true;
  var O = window.Olilu;
  if (!O) return;
  var $ = O.$, $$ = O.$$, esc = O.esc;
  var mqDesk = window.matchMedia('(min-width: 990px)');
  var mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var mqCalm = window.matchMedia('(prefers-reduced-motion: reduce)');

  function off(price, pct) { return Math.round(price * (100 - pct) / 100); }
  function behaviour() { return mqCalm.matches ? 'auto' : 'smooth'; }
  function onMq(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn); else mq.addListener(fn);
    return function () { if (mq.removeEventListener) mq.removeEventListener('change', fn); else mq.removeListener(fn); };
  }
  function thumbUrl(u) { return String(u).replace(/\.jpg(\?|$)/, '_240x240.jpg$1'); }
  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }

  /* ---------- Swatch photos: crop to the knit ----------
     The server cuts every swatch from the centre of the sibling's first visible photo, which suits any picture. On a
     studio photo (a light, even background) this goes one step further: it finds the knitted piece on a 48px copy of
     the photo and asks Shopify for a square inside it. A pair laid side by side then shows one glove's knit rather than
     the gap between them, and every swatch is filled with knit at a like scale. Anything else keeps the centred crop. */
  var knitSeen = {};
  function knitUrl(src, c, size) {
    var u = new URL(src, location.href);
    ['crop', 'crop_left', 'crop_top', 'crop_width', 'crop_height', 'width', 'height'].forEach(function (k) { u.searchParams.delete(k); });
    if (c) {
      u.searchParams.set('crop', 'region');
      u.searchParams.set('crop_left', c.l);
      u.searchParams.set('crop_top', c.t);
      u.searchParams.set('crop_width', c.s);
      u.searchParams.set('crop_height', c.s);
      u.searchParams.set('height', size);
    }
    u.searchParams.set('width', size);
    return u.toString();
  }
  function knitCrop(d, N, H, w, h) {
    var x, y, ring = [];
    function px(x, y) { var i = (y * N + x) * 4; return [d[i], d[i + 1], d[i + 2]]; }
    for (x = 0; x < N; x++) ring.push(px(x, 0), px(x, 1), px(x, H - 1), px(x, H - 2));
    for (y = 2; y < H - 2; y++) ring.push(px(0, y), px(1, y), px(N - 1, y), px(N - 2, y));
    var bg = [0, 0, 0];
    ring.forEach(function (c) { bg[0] += c[0]; bg[1] += c[1]; bg[2] += c[2]; });
    bg = bg.map(function (v) { return v / ring.length; });
    var dev = ring.reduce(function (s, c) { return s + Math.abs(c[0] - bg[0]) + Math.abs(c[1] - bg[1]) + Math.abs(c[2] - bg[2]); }, 0) / ring.length / 3;
    if ((bg[0] + bg[1] + bg[2]) / 3 < 185 || dev > 16) return null;
    function fg(x, y) { var c = px(x, y); return Math.abs(c[0] - bg[0]) + Math.abs(c[1] - bg[1]) + Math.abs(c[2] - bg[2]) > 60; }
    var col = [];
    for (x = 0; x < N; x++) { var n = 0; for (y = 0; y < H; y++) if (fg(x, y)) n++; col.push(n / H); }
    var cut = Math.max(0.2, Math.max.apply(null, col) * 0.5), runs = [], s = -1;
    for (x = 0; x <= N; x++) {
      var on = x < N && col[x] > cut;
      if (on && s < 0) s = x;
      if (!on && s >= 0) { if (x - s >= 3) runs.push([s, x]); s = -1; }
    }
    if (!runs.length) return null;
    var mid = N / 2;
    var dist = function (r) { return r[0] <= mid && r[1] >= mid ? 0 : Math.min(Math.abs(r[0] - mid), Math.abs(r[1] - mid)); };
    runs.sort(function (a, b) { return dist(a) - dist(b) || (b[1] - b[0]) - (a[1] - a[0]); });
    var r = runs[0], top = -1, bot = -1;
    for (y = 0; y < H; y++) {
      var m = 0;
      for (x = r[0]; x < r[1]; x++) if (fg(x, y)) m++;
      if (m / (r[1] - r[0]) > 0.3) { if (top < 0) top = y; bot = y + 1; }
    }
    if (top < 0) return null;
    var k = w / N, short = Math.min(w, h);
    var side = Math.max(short * 0.22, Math.min((r[1] - r[0]) * k * 0.8, (bot - top) * k * 0.8, short * 0.6));
    var cx = (r[0] + r[1]) / 2 * k, cy = (top + bot) / 2 * k;
    return {
      l: Math.round(Math.min(Math.max(cx - side / 2, 0), w - side)),
      t: Math.round(Math.min(Math.max(cy - side / 2, 0), h - side)),
      s: Math.round(side)
    };
  }
  function knit(imgs) {
    imgs.forEach(function (img) {
      if (img.__knit || !img.getClientRects().length) return;
      var wh = (img.getAttribute('data-sw') || '').split(','), w = Number(wh[0]), h = Number(wh[1]);
      if (!w || !h || !window.URL || !window.Promise) return;
      img.__knit = true;
      var size = (Number(img.getAttribute('width')) || 40) * 2;
      var key = img.src.split('?')[0];
      if (!knitSeen[key]) {
        knitSeen[key] = new Promise(function (done) {
          var a = new Image();
          a.crossOrigin = 'anonymous';
          a.onload = function () {
            try {
              var N = 48, H = Math.max(8, Math.round(N * h / w)), cv = document.createElement('canvas');
              cv.width = N;
              cv.height = H;
              var ctx = cv.getContext('2d');
              ctx.drawImage(a, 0, 0, N, H);
              done(knitCrop(ctx.getImageData(0, 0, N, H).data, N, H, w, h));
            } catch (e) { done(null); }
          };
          a.onerror = function () { done(null); };
          a.src = knitUrl(img.src, null, 64);
        });
      }
      knitSeen[key].then(function (c) { if (c) img.src = knitUrl(img.src, c, size); });
    });
  }

  /* ================================================================ Product main */
  O.ready('[data-pdp]', function (root) {
    var cleanups = root.__cleanups = [];
    var form = $('[data-pdp-form]', root);
    var idInput = $('[data-pdp-id]', root);
    var addBtn = $('[data-pdp-add]', root);
    var addLabel = $('[data-pdp-add-label]', root);
    var errorEl = $('[data-pdp-error]', root);
    var optsWrap = $('[data-pdp-options]', root);
    var unit = root.getAttribute('data-unit') || 'piece';
    var variants = [];
    try { variants = JSON.parse(($('[data-pdp-variants]', root) || {}).textContent || '[]'); } catch (e) { variants = []; }
    var needsChoice = !!(idInput && idInput.disabled);
    var state = {
      variant: needsChoice ? null : (variants.filter(function (v) { return idInput && String(v.id) === idInput.value; })[0] || variants[0] || null)
    };

    var gallery = initGallery(root);
    var pairs = initPairs(root, function () { render(); });
    initSwatches(root);
    initTabs(root, cleanups);
    initReviewLine(root);
    initWear(root);
    initAdReviews(root);

    /* ---------- Options ---------- */
    function readOpts() {
      return $$('[data-pdp-opt]', optsWrap).map(function (g) {
        var sel = $('[data-pdp-opt-select]', g);
        if (sel) return sel.value;
        var c = $('input:checked', g);
        return c ? c.value : null;
      });
    }
    function match(opts) {
      if (opts.some(function (o) { return o === null; })) return null;
      return variants.filter(function (v) { return v.o.every(function (o, i) { return o === opts[i]; }); })[0] || null;
    }
    function markOptions(opts) {
      $$('[data-pdp-opt]', optsWrap).forEach(function (g, i) {
        $$('input[type="radio"]', g).forEach(function (inp) {
          var ok = variants.some(function (v) {
            return v.a && v.o[i] === inp.value && v.o.every(function (o, j) { return j === i || opts[j] === null || opts[j] === o; });
          });
          var lab = inp.nextElementSibling;
          if (lab) {
            lab.classList.toggle('is-out', !ok);
            lab.title = ok ? '' : 'Sold out';
          }
        });
        var label = $('[data-pdp-opt-value]', g);
        if (label) label.textContent = opts[i] || '';
      });
    }
    if (optsWrap) {
      optsWrap.addEventListener('change', function () {
        var o = readOpts();
        markOptions(o);
        setVariant(match(o), true);
      });
      markOptions(readOpts());
    }

    /* ---------- Variant state ---------- */
    var low = Number(root.getAttribute('data-low')) || 3;
    function stockText(v) {
      if (!v) return 'In stock.';
      if (!v.a) return 'Sold out.';
      if (v.t === 'shopify' && v.pol === 'deny' && v.q > 0 && v.q <= low) return 'Only ' + v.q + ' left.';
      return 'In stock.';
    }
    function setVariant(v, user) {
      state.variant = v;
      if (errorEl) errorEl.hidden = true;
      if (v) {
        idInput.value = v.id;
        idInput.disabled = false;
        var price = $('[data-pdp-price]', root), was = $('[data-pdp-was]', root), wasAmt = $('[data-pdp-was-amt]', root);
        var sale = v.c > v.p;
        if (price) { price.textContent = O.money(v.p); price.classList.toggle('price--sale', sale); }
        if (was) was.hidden = !sale;
        if (wasAmt && sale) wasAmt.textContent = O.money(v.c);
        if (pairs) pairs.paint(v);
        var barName = $('[data-pdp-bar-name][data-opt]', root);
        if (barName && v.o[Number(barName.getAttribute('data-opt'))]) barName.textContent = v.o[Number(barName.getAttribute('data-opt'))];
        if (user) {
          try {
            var u = new URL(location.href);
            u.searchParams.set('variant', v.id);
            history.replaceState(history.state, '', u.toString());
          } catch (e) { /* ignore */ }
          if (v.m && gallery) gallery.showMedia(v.m);
        }
        var body = $('[data-pdp-notify-body]', root);
        if (body) {
          var title = norm(($('.pdp__title', root) || {}).textContent);
          body.value = 'Please email me when ' + title + (v.o.length ? ' (' + v.o.join(' / ') + ')' : '') + ' is back in stock.';
        }
      }
      render();
    }

    function render() {
      var v = state.variant;
      var dyn = $('[data-pdp-dynamic]', root), notify = $('[data-pdp-notify]', root);
      var stock = $('[data-pdp-stock]', root), dot = $('[data-pdp-dot]', root), eta = $('[data-pdp-eta]', root);
      var soldOut = !!(v && !v.a);
      var label;
      if (!v) label = root.getAttribute('data-choose') || 'Choose a size';
      else if (!v.a) label = 'Sold out';
      else {
        var n = pairs ? pairs.n() : 1;
        label = n > 1 ? 'Add ' + n + ' ' + unit + 's · ' + O.money(pairs.total(v)) : 'Add to basket · ' + O.money(v.p);
      }
      if (addBtn) {
        /* Still pressable before a size is chosen: it then points to the sizes instead of doing nothing */
        addBtn.disabled = soldOut;
        addBtn.hidden = soldOut;
        addBtn.classList.toggle('is-choose', !v);
      }
      if (addLabel) addLabel.textContent = label;
      if (dyn) { dyn.hidden = soldOut; dyn.classList.toggle('is-pending', !v); }
      if (notify) notify.hidden = !soldOut;
      if (stock) stock.textContent = stockText(v);
      if (dot) dot.hidden = soldOut;
      if (eta) eta.hidden = soldOut;
      var bar = $('[data-pdp-bar]', root);
      if (bar) {
        var bp = $('[data-pdp-bar-price]', bar), bb = $('[data-pdp-bar-add]', bar);
        if (bp && v) {
          var bn = pairs ? pairs.n() : 1;
          bp.textContent = bn > 1 && v.a ? bn + ' ' + unit + 's · ' + O.money(pairs.total(v)) : O.money(v.p);
        }
        if (bb) { bb.disabled = soldOut; bb.textContent = soldOut ? 'Sold out' : 'Add to basket'; }
      }
    }

    /* ---------- Add to basket ---------- */
    function focusOptions() {
      if (!optsWrap) return;
      optsWrap.scrollIntoView({ block: 'center', behavior: behaviour() });
      var g = $$('[data-pdp-opt]', optsWrap).filter(function (x) { return !$('input:checked', x) && !$('select', x); })[0];
      var f = g && $('input', g);
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 300);
      if (errorEl && g) {
        var choose = (root.getAttribute('data-choose') || 'Choose a size').replace(/^Choose/, 'choose');
        errorEl.textContent = 'Please ' + choose + '.';
        errorEl.hidden = false;
      }
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = state.variant;
        if (!v) { focusOptions(); return; }
        if (!v.a || (addBtn && addBtn.classList.contains('is-loading'))) return;
        var items = pairs ? pairs.items(v) : [{ id: v.id, quantity: 1 }];
        if (errorEl) errorEl.hidden = true;
        if (addBtn) { addBtn.classList.add('is-loading'); addBtn.setAttribute('aria-busy', 'true'); }
        O.cart.add(items).then(function () {
          O.basket.open(addBtn);
        }).catch(function (err) {
          if (errorEl) {
            errorEl.textContent = (err && err.message) || "Sorry, that didn't work. Please try again.";
            errorEl.hidden = false;
          }
        }).then(function () {
          if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy'); }
        });
      });
    }

    /* ---------- Phone bar ---------- */
    var bar = $('[data-pdp-bar]', root), buy = $('.pdp__buy', root);
    var anyAvailable = variants.some(function (v) { return v.a; });
    if (bar && buy && anyAvailable) {
      /* Measured on scroll rather than with IntersectionObserver: a jump (back to top, an anchor link) can carry the
         button from below the screen to above it without ever crossing it, and an observer never hears about that. */
      var foot = document.querySelector('.shopify-section-group-footer-group, footer');
      var barTick = false;
      var paintBar = function () {
        barTick = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var past = buy.getBoundingClientRect().bottom < 0;
        var footer = !!foot && foot.getBoundingClientRect().top < vh;
        var on = past && !footer && !mqDesk.matches;
        bar.classList.toggle('is-visible', on);
        if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      };
      var onBarScroll = function () { if (!barTick) { barTick = true; requestAnimationFrame(paintBar); } };
      window.addEventListener('scroll', onBarScroll, { passive: true });
      window.addEventListener('resize', onBarScroll);
      paintBar();
      cleanups.push(function () { window.removeEventListener('scroll', onBarScroll); window.removeEventListener('resize', onBarScroll); bar.classList.remove('is-visible'); });
      cleanups.push(onMq(mqDesk, paintBar));
      $('[data-pdp-bar-add]', bar).addEventListener('click', function () {
        if (!state.variant) { focusOptions(); return; }
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    /* ---------- Delivery: Christmas line follows today's date, not the cached page ---------- */
    var xmas = $('[data-pdp-xmas]', root);
    if (xmas) { try { xmas.hidden = !O.delivery().xmas; } catch (e) { /* keep server state */ } }

    render();
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-pdp]');
    if (root) teardown(root);
  });

  function teardown(root) {
    (root.__cleanups || []).forEach(function (fn) { try { fn(); } catch (e) { /* ignore */ } });
    root.__cleanups = [];
    var d = document.getElementById('SizeGuide-' + root.getAttribute('data-section'));
    if (d && !root.contains(d)) {
      if (d.classList.contains('is-open')) O.drawer.close(d);
      d.parentNode.removeChild(d);
    }
  }

  /* ---------- Gallery ----------
     Thumbnails down the left at every width; the photos share one frame and only the active one shows. A tap swaps the
     photo at once: a thumbnail's photo starts loading on touch, hover or focus, and until it has loaded the last photo
     that actually appeared stays underneath (.is-under), so the frame never goes blank, even when taps outrun the
     network. The thumbnails are one Tab stop (the current one); the arrow keys, Home and End move between them. */
  function initGallery(root) {
    var track = $('[data-pdp-track]', root);
    if (!track) return null;
    var slides = $$('[data-pdp-slide]', track);
    var thumbs = $$('[data-pdp-thumb]', root);
    var rail = $('.pdp__rail', root);
    var stage = $('.pdp__stage', root);
    var zoomCur = $('[data-pdp-zoom-cur]', root);
    var countN = $('[data-pdp-count-n]', root);
    var idx = Math.max(0, slides.map(function (s) { return s.classList.contains('is-active'); }).indexOf(true));
    var under = null, turn = 0;

    function photo(n) { return slides[n] ? $('.pdp__zoom-btn > img', slides[n]) : null; }
    function warm(n) { var img = photo(n); if (img && img.loading === 'lazy') img.loading = 'eager'; }
    function isLoaded(img) { return !!(img && img.complete && img.naturalWidth); }
    function shown(s) { var img = $('.pdp__zoom-btn > img', s); return !img || isLoaded(img); }

    function setActive(i) {
      if (i < 0 || i >= slides.length) return;
      var prev = slides[idx], next = slides[i];
      if (prev !== next) {
        warm(i);
        var img = photo(i);
        /* Underneath goes the previous photo if it has appeared, otherwise whatever is underneath already */
        var base = shown(prev) ? prev : under;
        if (under) under.classList.remove('is-under');
        under = null;
        var t = ++turn;
        if (img && !isLoaded(img) && base && base !== next) {
          under = base;
          base.classList.add('is-under');
          var lift = function () {
            if (t !== turn) return;
            base.classList.remove('is-under');
            under = null;
          };
          if (img.decode) img.decode().then(lift, lift);
          else { img.addEventListener('load', lift, { once: true }); img.addEventListener('error', lift, { once: true }); }
        }
        prev.classList.remove('is-active');
        next.classList.add('is-active');
        $$('video', prev).forEach(function (v) { try { v.pause(); } catch (e) { /* ignore */ } });
        if (i + 1 < slides.length) setTimeout(function () { warm(i + 1); }, 500);
      }
      idx = i;
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.tabIndex = n === i ? 0 : -1;
        if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      var z = $('[data-pdp-zoom-open]', next);
      if (zoomCur) {
        zoomCur.hidden = !z;
        if (z) zoomCur.setAttribute('data-pdp-zoom-open', z.getAttribute('data-pdp-zoom-open'));
      }
      if (stage) stage.classList.toggle('is-media', !z);
      if (countN) countN.textContent = String(i + 1);
      var li = thumbs[i] && thumbs[i].parentNode;
      if (li && rail && rail.scrollHeight > rail.clientHeight) {
        var top = li.offsetTop, bottom = top + li.offsetHeight, to = null;
        if (top < rail.scrollTop) to = top;
        else if (bottom > rail.scrollTop + rail.clientHeight) to = bottom - rail.clientHeight;
        if (to !== null) rail.scrollTo({ top: to, behavior: behaviour() });
      }
    }
    thumbs.forEach(function (t) {
      var n = Number(t.getAttribute('data-pdp-thumb'));
      var pre = function () { warm(n); };
      t.addEventListener('click', function () { setActive(n); });
      t.addEventListener('pointerenter', pre);
      t.addEventListener('focus', pre);
      t.addEventListener('touchstart', pre, { passive: true });
    });
    var gal = $('[data-pdp-gallery]', root);
    if (gal) {
      gal.addEventListener('keydown', function (e) {
        var k = e.key, onThumb = !!e.target.closest('[data-pdp-thumb]');
        var d = (k === 'ArrowDown' || k === 'ArrowRight') ? 1 : (k === 'ArrowUp' || k === 'ArrowLeft') ? -1 : 0;
        var n = onThumb && k === 'Home' ? 0 : onThumb && k === 'End' ? slides.length - 1 : d ? idx + d : null;
        if (n === null || e.altKey || e.metaKey || e.ctrlKey) return;
        e.preventDefault();
        n = Math.max(0, Math.min(slides.length - 1, n));
        setActive(n);
        var zb = !onThumb && e.target.closest('.pdp__zoom-btn') && $('.pdp__zoom-btn', slides[n]);
        if (onThumb && thumbs[n]) thumbs[n].focus();
        else if (zb) zb.focus({ preventScroll: true });
      });
    }

    setActive(idx);
    if (zoomCur && !slides.length) zoomCur.hidden = true;
    /* The second photo is the likeliest next tap: fetch it once the page has settled */
    if (slides.length > 1) {
      var soon = function () {
        if ('requestIdleCallback' in window) window.requestIdleCallback(function () { warm(1); }, { timeout: 4000 });
        else setTimeout(function () { warm(1); }, 2000);
      };
      if (document.readyState === 'complete') soon(); else window.addEventListener('load', soon, { once: true });
    }

    /* Desktop hover: the flat-lay gives way to the on-hand photo (media 2) */
    var tpl = $('[data-pdp-hover]', root);
    if (tpl && tpl.content && slides[0]) {
      var s0 = slides[0], loaded = false;
      var load = function () {
        if (loaded || !mqHover.matches || !mqDesk.matches) return;
        loaded = true;
        var img = tpl.content.firstElementChild && tpl.content.firstElementChild.cloneNode(true);
        var btn = $('.pdp__zoom-btn', s0);
        if (!img || !btn) return;
        img.addEventListener('load', function () { s0.classList.add('has-hover'); });
        btn.appendChild(img);
        if (img.complete && img.naturalWidth) s0.classList.add('has-hover');
      };
      s0.addEventListener('pointerenter', load);
      if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 5000 });
      else setTimeout(load, 3000);
    }

    /* Zoom */
    var dlg = $('[data-pdp-zoom]', root);
    if (dlg && typeof dlg.showModal === 'function') {
      var list = $('[data-pdp-zoom-list]', dlg);
      var items = $$('[data-pdp-zoom-item]', dlg);
      var count = $('[data-pdp-zoom-count]', dlg);
      var zi = 0, opener = null;
      var zGo = function (n, smooth) {
        if (!items.length) return;
        zi = Math.max(0, Math.min(items.length - 1, n));
        list.scrollTo({ top: Math.max(0, items[zi].offsetTop - 16), behavior: smooth ? behaviour() : 'auto' });
        if (count) count.textContent = (zi + 1) + ' of ' + items.length;
      };
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-pdp-zoom-open]');
        if (!b || !items.length) return;
        var mi = Number(b.getAttribute('data-pdp-zoom-open'));
        var n = 0;
        items.forEach(function (it, k) { if (Number(it.getAttribute('data-pdp-zoom-item')) === mi) n = k; });
        /* The magnifier is hidden from assistive tech, so closing returns focus to the photo's own labelled button */
        opener = (b.hasAttribute('data-pdp-zoom-cur') && slides[idx] && $('.pdp__zoom-btn', slides[idx])) || b;
        dlg.showModal();
        O.lock(true);
        list.focus({ preventScroll: true });
        zGo(n, false);
        requestAnimationFrame(function () { if (zi === n) zGo(n, false); });
      });
      dlg.addEventListener('close', function () {
        O.lock(false);
        if (opener && opener.focus) opener.focus({ preventScroll: true });
      });
      $('[data-pdp-zoom-close]', dlg).addEventListener('click', function () { dlg.close(); });
      $$('[data-pdp-zoom-step]', dlg).forEach(function (b) {
        b.addEventListener('click', function () { zGo(zi + Number(b.getAttribute('data-pdp-zoom-step')), true); });
      });
      dlg.addEventListener('keydown', function (e) {
        var d = (e.key === 'ArrowDown' || e.key === 'ArrowRight' || e.key === 'PageDown') ? 1 : (e.key === 'ArrowUp' || e.key === 'ArrowLeft' || e.key === 'PageUp') ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        zGo(zi + d, true);
      });
      /* The count follows the reader's scrolling, but keeps the photo it was opened or stepped to while that photo is
         still mostly in view: the last photos can never reach the top of the list, so the top-third rule alone would
         call photo 3 of 3 "2 of 3". At the very bottom it is the last photo. */
      list.addEventListener('scroll', O.debounce(function () {
        var vt = list.scrollTop, vh = list.clientHeight, top = vt + vh / 3, n = 0;
        var cur = items[zi];
        if (cur) {
          var seen = Math.min(cur.offsetTop + cur.offsetHeight, vt + vh) - Math.max(cur.offsetTop, vt);
          if (seen > Math.min(cur.offsetHeight, vh) * 0.6) return;
        }
        items.forEach(function (it, k) { if (it.offsetTop <= top) n = k; });
        if (vt + vh >= list.scrollHeight - 2) n = items.length - 1;
        zi = n;
        if (count) count.textContent = (zi + 1) + ' of ' + items.length;
      }, 80), { passive: true });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }

    return {
      showMedia: function (mediaId) {
        var s = slides.filter(function (x) { return x.getAttribute('data-media-id') === String(mediaId); })[0];
        if (s) setActive(Number(s.getAttribute('data-pdp-slide')));
      }
    };
  }

  /* ---------- Colour swatches: swap the section in place ---------- */
  var sectionCache = {};
  function fetchPdp(url, sid) {
    var key = sid + '|' + url;
    if (!sectionCache[key]) {
      sectionCache[key] = O.section(url, sid);
      sectionCache[key].catch(function () { delete sectionCache[key]; });
    }
    return sectionCache[key];
  }
  function initSwatches(root) {
    var wrap = $('[data-pdp-colours]', root);
    if (!wrap) return;
    var sid = root.getAttribute('data-section');
    var list = $('[data-pdp-sws]', wrap), more = $('[data-pdp-sws-more]', wrap);
    var runKnit = function () { knit($$('img[data-sw]', list)); };
    function open() {
      list.classList.add('is-open');
      if (more) { more.setAttribute('aria-expanded', 'true'); more.hidden = true; }
      runKnit();
    }
    O.inView(wrap, function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(runKnit, { timeout: 1500 });
      else setTimeout(runKnit, 200);
    }, '200px');
    if (more) more.addEventListener('click', open);
    var cur = $('[aria-current="true"]', list);
    if (cur && cur.offsetParent === null) open();
    /* Browsers without :has() cannot hide the button by CSS when every colour already fits in two rows */
    var hasHas = false;
    try { hasHas = CSS.supports('selector(:has(*))'); } catch (e) { hasHas = false; }
    if (more && !hasHas && !$$('li', list).some(function (li) { return li.offsetParent === null; })) more.hidden = true;
    $$('[data-pdp-swatch]', wrap).forEach(function (a) {
      var pre = function () { if (a.getAttribute('aria-current') !== 'true') fetchPdp(a.href, sid).catch(function () {}); };
      a.addEventListener('pointerenter', pre);
      a.addEventListener('focus', pre);
      a.addEventListener('touchstart', pre, { passive: true });
      a.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        if (a.getAttribute('aria-current') === 'true') return;
        swap(root, a.href);
      });
    });
  }
  function swap(root, url) {
    var sid = root.getAttribute('data-section');
    if (root.classList.contains('is-swapping')) return;
    root.classList.add('is-swapping');
    root.setAttribute('aria-busy', 'true');
    fetchPdp(url, sid).then(function (html) {
      var fresh = O.parse(html).querySelector('[data-pdp]');
      if (!fresh) throw new Error('No product section');
      var parent = root.parentNode;
      teardown(root);
      var node = document.importNode(fresh, true);
      parent.replaceChild(node, root);
      try { history.replaceState(history.state, '', url); } catch (e) { /* ignore */ }
      if (node.getAttribute('data-title')) document.title = node.getAttribute('data-title');
      O.init(parent);
      var sw = $('[data-pdp-swatch][aria-current="true"]', node);
      if (sw) sw.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('olilu:product-swap', { detail: { url: url } }));
    }).catch(function () { location.href = url; });
  }

  /* ---------- "How many pairs?" ---------- */
  function initPairs(root, onChange) {
    var el = $('[data-pairs]', root);
    if (!el) return null;
    var q1 = Number(el.getAttribute('data-q1')) || 2, q2 = Number(el.getAttribute('data-q2')) || 3;
    var p1 = Number(el.getAttribute('data-p1')) || 0, p2 = Number(el.getAttribute('data-p2')) || 0;
    var picks = $('[data-pairs-picks]', el), helper = $('[data-pairs-helper]', el);
    var rows = $$('[data-pairs-pick]', el);
    function n() { var c = $('[data-pairs-n]:checked', el); return c ? Number(c.value) : 1; }
    function pct(k) { return k >= q2 ? p2 : k >= q1 ? p1 : 0; }
    function chosen(row) {
      var sel = $('[data-pairs-select]', row);
      return sel ? sel.options[sel.selectedIndex] : $('input:checked', row);
    }
    function extras() {
      var k = n(), out = [];
      rows.forEach(function (row) {
        if (Number(row.getAttribute('data-pairs-pick')) > k) return;
        var c = chosen(row);
        if (c) out.push({ id: Number(c.value), price: Number(c.getAttribute('data-price')) || 0 });
      });
      return out;
    }
    function lines(v) {
      var k = n(), out = [{ id: v.id, price: v.p }];
      extras().forEach(function (x) { out.push(x); });
      while (out.length < k) out.push({ id: v.id, price: v.p });
      return out.slice(0, k);
    }
    function sync() {
      var k = n();
      if (picks) {
        picks.hidden = k < 2 || !rows.length;
        rows.forEach(function (row) { row.hidden = Number(row.getAttribute('data-pairs-pick')) > k; });
      }
      rows.forEach(function (row) {
        var c = chosen(row), name = $('[data-pairs-pick-name]', row);
        if (c && name) name.textContent = c.getAttribute('data-name') || '';
      });
      if (helper) helper.hidden = k !== 2;
      if (k > 1 && picks) knit($$('img[data-sw]', picks));
    }
    el.addEventListener('change', function (e) {
      /* A colour the shopper picks for an extra piece stays put; untouched ones keep following the main choice */
      if (e.target && e.target.matches && e.target.matches('[data-pairs-select]')) e.target.removeAttribute('data-follow');
      sync();
      onChange();
    });
    sync();
    return {
      n: n,
      items: function (v) { return lines(v).map(function (x) { return { id: x.id, quantity: 1 }; }); },
      total: function (v) {
        var p = pct(n());
        return lines(v).reduce(function (s, x) { return s + off(x.price, p); }, 0);
      },
      paint: function (v) {
        $$('[data-pairs-select][data-follow]', el).forEach(function (sel) {
          var o = $$('option', sel).filter(function (x) { return x.value === String(v.id) && !x.disabled; })[0];
          if (o) sel.value = o.value;
        });
        sync();
        [1, q1, q2].forEach(function (k) {
          var tot = $('[data-pairs-total="' + k + '"]', el), save = $('[data-pairs-save="' + k + '"]', el);
          var e = off(v.p, pct(k));
          if (tot) tot.textContent = O.money(e * k);
          if (save) save.textContent = 'Save ' + O.money((v.p - e) * k);
        });
      }
    };
  }

  /* ---------- Tabs (desktop) / accordions (phones) ---------- */
  function initTabs(root, cleanups) {
    var wrap = $('[data-pdp-tabs]', root);
    if (!wrap) return;
    var tabs = $$('[role="tab"]', wrap), items = $$('[data-pdp-tab]', wrap);
    var active = 0;
    function select(i, focus) {
      active = i;
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      if (mqDesk.matches) items.forEach(function (d, n) { d.open = n === i; });
    }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { select(i, false); }); });
    var tl = $('[role="tablist"]', wrap);
    if (tl) {
      tl.addEventListener('keydown', function (e) {
        var i = e.key === 'ArrowRight' ? active + 1 : e.key === 'ArrowLeft' ? active - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
        if (i === null) return;
        e.preventDefault();
        select((i + tabs.length) % tabs.length, true);
      });
    }
    function mode() { if (mqDesk.matches) select(active, false); }
    mode();
    wrap.classList.add('is-ready');
    cleanups.push(onMq(mqDesk, mode));
  }

  /* ---------- Newest review of this design ----------
     A fixed rule, whatever the rating: the newest review of this design with a customer photo; when the design has
     none, the newest written review of at least 30 characters. The label says which rule picked it. */
  function lineHtml(r) {
    var photo = (r[4] || [])[0], h = '';
    if (photo) {
      h += '<a class="pdp__review-photo" href="' + esc(photo) + '" target="_blank" rel="noopener" aria-label="Customer photo from ' + esc(r[2] || 'a customer') + ', opens full size">' +
        '<img src="' + esc(thumbUrl(photo)) + '" alt="Photo from ' + esc(r[2] || 'a customer') + '" width="80" height="80" loading="lazy"></a>';
    }
    h += '<div class="pdp__review-body"><p class="pdp__review-label">' + (photo ? 'Newest photo review of this design' : 'Newest review of this design') + '</p>';
    h += '<p class="pdp__review-text">' + O.reviews.stars(r[0], 'stars--sm') + ' ' + esc(norm(r[1])) + '</p>';
    h += '<p class="pdp__review-meta">' + esc(r[2] || 'Etsy buyer') + ' · ' + esc(r[3] || '') + ' · Etsy review · <a href="#reviews">Read all</a></p></div>';
    return h;
  }
  function initReviewLine(root) {
    var el = $('[data-pdp-review]', root);
    var fam = el && el.getAttribute('data-family');
    if (!el || !fam) return;
    O.inView(el, function () {
      O.reviews.load(fam).then(function (d) {
        var ok = (d.r || []).filter(O.reviews.featurable);
        var r = ok.filter(function (x) { return x[4] && x[4].length; })[0] ||
          ok.filter(function (x) { return norm(x[1]).length >= 30; })[0];
        if (!r) return;
        var cur = $('.pdp__review-text', el);
        var same = cur && norm(cur.textContent).indexOf(norm(r[1]).slice(0, 40)) > -1;
        var samePhoto = !!$('.pdp__review-photo', el) === !!(r[4] && r[4].length);
        if (same && samePhoto) return;
        el.innerHTML = lineHtml(r);
      }).catch(function () { /* keep the server fallback */ });
    }, '800px');
  }

  /* ---------- Ad template: the two newest reviews under the button ---------- */
  function initAdReviews(root) {
    var el = $('[data-pdp-adrev]', root);
    if (!el) return;
    var list = $('[data-pdp-adrev-list]', el), fam = el.getAttribute('data-family');
    var written = function (d) { return (d.r || []).filter(O.reviews.featurable); };
    var shop = function () { return O.reviews.load('shop').then(function (s) { return { r: s.recent || [], shop: true }; }); };
    var src = (fam && el.getAttribute('data-scope') !== 'shop') ?
      O.reviews.load(fam).then(function (d) { return written(d).length ? d : shop(); }, shop) : shop();
    src.then(function (d) {
      list.innerHTML = written(d).slice(0, 2).map(function (r) { return O.reviews.card(r, { cls: 'letter--compact', product: !!d.shop }); }).join('');
    }).catch(function () { /* the summary stays */ });
  }

  /* ---------- "Wear it with" ---------- */
  function initWear(root) {
    var el = $('[data-wear]', root);
    if (!el) return;
    var btn = $('[data-wear-add]', el), total = $('[data-wear-total]', el), err = $('[data-wear-error]', el);
    function checked() { return $$('[data-wear-check]:checked', el); }
    function rowOf(x) { return x.closest('[data-wear-row]'); }
    function paint() {
      var c = checked();
      btn.hidden = !c.length;
      total.textContent = O.money(c.reduce(function (s, x) { return s + (Number(x.getAttribute('data-price')) || 0); }, 0));
    }
    /* A row's select sets what its box adds; choosing an option also ticks the box */
    el.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-wear-select]');
      if (sel) {
        var row = rowOf(sel), box = row && $('[data-wear-check]', row), o = sel.options[sel.selectedIndex];
        if (box && o) {
          box.value = o.value;
          box.setAttribute('data-price', o.getAttribute('data-price') || box.getAttribute('data-price'));
          var pr = $('[data-wear-price]', row);
          if (pr && o.value) pr.textContent = O.money(Number(o.getAttribute('data-price')) || 0);
          if (o.value) box.checked = true;
        }
        err.hidden = true;
      }
      paint();
    });
    btn.addEventListener('click', function () {
      var c = checked();
      if (!c.length || btn.classList.contains('is-loading')) return;
      var missing = c.filter(function (x) { return !x.value; })[0];
      if (missing) {
        var s = $('[data-wear-select]', rowOf(missing));
        err.textContent = 'Please ' + ((s && s.options[0] && s.options[0].text) || 'choose a size').replace(/^Choose/, 'choose') + ' for ' + norm(($('.wear__name', rowOf(missing)) || {}).textContent) + '.';
        err.hidden = false;
        if (s) s.focus();
        return;
      }
      btn.classList.add('is-loading');
      err.hidden = true;
      O.cart.add(c.map(function (x) { return { id: Number(x.value), quantity: 1 }; })).then(function () {
        c.forEach(function (x) { x.checked = false; });
        paint();
        O.basket.open($('[data-wear-check]', el) || el);
      }).catch(function (e) {
        err.textContent = (e && e.message) || "Sorry, that didn't work. Please try again.";
        err.hidden = false;
      }).then(function () { btn.classList.remove('is-loading'); });
    });
    paint();
  }

  /* ================================================================ Reviews section */
  O.ready('[data-pdp-reviews]', function (sec) {
    var fam = sec.getAttribute('data-family');
    var per = Number(sec.getAttribute('data-per')) || 6;
    var list = $('[data-rv-list]', sec), more = $('[data-rv-more]', sec), status = $('[data-rv-status]', sec);
    var sortSel = $('[data-rv-sort]', sec), photosCb = $('[data-rv-photos]', sec), clearBtn = $('[data-rv-clear]', sec);
    var toggle = $('[data-rv-toggle]', sec), controls = $('[data-rv-controls]', sec), histWrap = $('[data-rv-hist]', sec);
    var st = { mode: 'design', sort: 'newest', star: 0, photos: false, shown: per };
    var sets = {}, data = null;
    var SORTS = { newest: 'newest first', oldest: 'oldest first', highest: 'highest rating first', lowest: 'lowest rating first' };

    function shopSet() {
      return O.reviews.load('shop').then(function (d) {
        return { avg: d.avg, count: d.count, hist: d.hist, r: d.recent || [], products: true, fallback: true,
          scope: 'This design is new, so these are the newest reviews from across our Etsy shop' };
      });
    }
    function get(mode) {
      if (sets[mode]) return Promise.resolve(sets[mode]);
      var p;
      if (mode === 'all') {
        p = O.reviews.load('all').then(function (d) {
          return { avg: d.avg, count: d.count, hist: d.hist, r: d.r || [], products: true, scope: 'Every design in our Etsy shop' };
        });
      } else {
        p = (fam ? O.reviews.load(fam) : Promise.reject(new Error('none'))).then(function (d) {
          return { avg: d.avg, count: d.count, hist: d.hist, r: d.r || [], products: false, scope: 'All colours of this design' };
        }, shopSet);
      }
      return p.then(function (d) { sets[mode] = d; return d; });
    }
    function rows() {
      var r = data.r.map(function (x, i) { return { x: x, i: i }; });
      if (st.star) r = r.filter(function (o) { return Number(o.x[0]) === st.star; });
      if (st.photos) r = r.filter(function (o) { return o.x[4] && o.x[4].length; });
      if (st.sort === 'oldest') r.reverse();
      else if (st.sort === 'highest') r.sort(function (a, b) { return b.x[0] - a.x[0] || a.i - b.i; });
      else if (st.sort === 'lowest') r.sort(function (a, b) { return a.x[0] - b.x[0] || a.i - b.i; });
      return r.map(function (o) { return o.x; });
    }
    function paintSummary() {
      var avg = Number(data.avg) || 0;
      $('[data-rv-avg]', sec).textContent = avg.toFixed(1);
      var stars = $('[data-rv-stars]', sec);
      if (stars) { stars.style.setProperty('--pct', (avg * 20) + '%'); stars.setAttribute('aria-label', avg.toFixed(1) + ' out of 5 stars'); }
      $('[data-rv-count]', sec).textContent = Number(data.count || 0).toLocaleString('en-GB');
      var noun = $('[data-rv-noun]', sec);
      if (noun) noun.textContent = Number(data.count) === 1 ? 'Etsy review' : 'Etsy reviews';
      $('[data-rv-scope]', sec).textContent = data.scope;
      histWrap.innerHTML = O.reviews.hist(data.hist || [], { buttons: true });
      paintPressed();
    }
    function paintPressed() {
      $$('[data-star]', histWrap).forEach(function (b) { b.setAttribute('aria-pressed', Number(b.getAttribute('data-star')) === st.star ? 'true' : 'false'); });
      if (clearBtn) clearBtn.hidden = !st.star;
    }
    function paintList(focusFrom) {
      var all = rows(), shown = all.slice(0, st.shown);
      if (shown.length) {
        list.innerHTML = shown.map(function (r) { return O.reviews.card(r, { product: data.products }); }).join('');
      } else {
        var msg = st.star ? 'No written ' + st.star + '-star reviews' + (st.photos ? ' with photos' : '') + ' yet.' :
          st.photos ? 'No reviews with photos yet.' : 'No written reviews yet. Every rating so far is a star rating without comments.';
        list.innerHTML = '<p class="pdr__empty">' + msg + '</p>';
      }
      more.hidden = all.length <= st.shown;
      status.textContent = shown.length ? 'Showing ' + shown.length + ' of ' + all.length.toLocaleString('en-GB') + ' written reviews, ' + SORTS[st.sort] + '.' : '';
      if (focusFrom != null) {
        var c = $$('.letter', list)[focusFrom];
        if (c) { c.setAttribute('tabindex', '-1'); c.focus({ preventScroll: false }); }
      }
    }
    function load(mode) {
      sec.setAttribute('aria-busy', 'true');
      return get(mode).then(function (d) {
        data = d;
        st.star = 0;
        st.shown = per;
        paintSummary();
        paintList();
        controls.hidden = false;
        if (toggle) toggle.hidden = !!(sets.design && sets.design.fallback);
      }).catch(function () {
        status.textContent = 'Sorry, the reviews did not load. Please refresh the page to try again.';
      }).then(function () { sec.removeAttribute('aria-busy'); });
    }

    histWrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-star]');
      if (!b || !data) return;
      var s = Number(b.getAttribute('data-star'));
      st.star = st.star === s ? 0 : s;
      st.shown = per;
      paintPressed();
      paintList();
    });
    if (clearBtn) clearBtn.addEventListener('click', function () { st.star = 0; st.shown = per; paintPressed(); paintList(); });
    sortSel.addEventListener('change', function () { st.sort = sortSel.value; st.shown = per; if (data) paintList(); });
    photosCb.addEventListener('change', function () { st.photos = photosCb.checked; st.shown = per; if (data) paintList(); });
    more.addEventListener('click', function () {
      var from = st.shown;
      st.shown += per;
      paintList(from);
    });
    if (toggle) {
      toggle.addEventListener('click', function (e) {
        var b = e.target.closest('[data-rv-mode]');
        if (!b) return;
        var m = b.getAttribute('data-rv-mode');
        if (m === st.mode) return;
        st.mode = m;
        $$('[data-rv-mode]', toggle).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        load(m);
      });
    }
    O.inView(sec, function () { load('design'); }, '400px');
  });

  /* ================================================================ You may also like */
  O.ready('[data-pdp-recs]', function (sec) {
    var url = sec.getAttribute('data-url');
    if (!url || /product_id=(&|$)/.test(url)) return;
    var cat = sec.getAttribute('data-cat'), fam = sec.getAttribute('data-family'), extra = sec.getAttribute('data-extra');
    function get(u) {
      if (!u) return Promise.resolve('');
      return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    }
    O.inView(sec.parentNode || sec, function () {
      Promise.all([get(url), get(extra)]).then(function (res) {
        /* Other categories only, one card per design, and a spread of categories: one per category (Shopify's
           suggestions first, then best sellers), then the next best to fill four */
        var seen = {}, cats = {}, pool = [], out = [];
        if (fam) seen[fam] = true;
        var items = [];
        res.forEach(function (html) { if (html) items = items.concat($$('[data-rec-item]', O.parse(html))); });
        items.forEach(function (li) {
          var c = li.getAttribute('data-cat'), f = li.getAttribute('data-family');
          if ((cat && c === cat) || seen[f]) return;
          seen[f] = true;
          pool.push(li);
        });
        pool.forEach(function (li) {
          var c = li.getAttribute('data-cat');
          if (out.length < 4 && !cats[c]) { cats[c] = true; out.push(li); }
        });
        pool.forEach(function (li) { if (out.length < 4 && out.indexOf(li) < 0) out.push(li); });
        out.sort(function (a, b) { return pool.indexOf(a) - pool.indexOf(b); });
        if (!out.length) return;
        var ul = $('[data-recs-list]', sec);
        ul.innerHTML = '';
        out.forEach(function (li) { ul.appendChild(document.importNode(li, true)); });
        sec.hidden = false;
        O.init(sec);
      }).catch(function () { /* stays hidden */ });
    }, '600px');
  });
})();
